/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetJobConfigDto
 */
export interface GetJobConfigDto {
    /**
     * 
     * @type {string}
     * @memberof GetJobConfigDto
     */
    id: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetJobConfigDto
     */
    active: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetJobConfigDto
     */
    systemNumber: number;
    /**
     * 
     * @type {string}
     * @memberof GetJobConfigDto
     */
    type: GetJobConfigDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetJobConfigDto
     */
    crone: string;
    /**
     * 
     * @type {string}
     * @memberof GetJobConfigDto
     */
    queueName: string;
    /**
     * 
     * @type {string}
     * @memberof GetJobConfigDto
     */
    croneDescription: string;
    /**
     * 
     * @type {Date}
     * @memberof GetJobConfigDto
     */
    nextStart: Date;
}


/**
 * @export
 */
export const GetJobConfigDtoTypeEnum = {
    OrderSynevoDownload: 'OrderSynevoDownload',
    KsefUpoPoll: 'KsefUpoPoll',
    SimP1JudgmentSend: 'SimP1JudgmentSend',
    FaceIdentityRetention: 'FaceIdentityRetention',
    AutomaticJudgment: 'AutomaticJudgment',
    AttachmentObjectStorageMigration: 'AttachmentObjectStorageMigration',
    InvoicePaymentReminder: 'InvoicePaymentReminder',
    TfaCleanup: 'TfaCleanup',
    AutoInvoiceGeneration: 'AutoInvoiceGeneration'
} as const;
export type GetJobConfigDtoTypeEnum = typeof GetJobConfigDtoTypeEnum[keyof typeof GetJobConfigDtoTypeEnum];


/**
 * Check if a given object implements the GetJobConfigDto interface.
 */
export function instanceOfGetJobConfigDto(value: object): value is GetJobConfigDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    if (!('systemNumber' in value) || value['systemNumber'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('crone' in value) || value['crone'] === undefined) return false;
    if (!('queueName' in value) || value['queueName'] === undefined) return false;
    if (!('croneDescription' in value) || value['croneDescription'] === undefined) return false;
    if (!('nextStart' in value) || value['nextStart'] === undefined) return false;
    return true;
}

export function GetJobConfigDtoFromJSON(json: any): GetJobConfigDto {
    return GetJobConfigDtoFromJSONTyped(json, false);
}

export function GetJobConfigDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetJobConfigDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'active': json['active'],
        'systemNumber': json['systemNumber'],
        'type': json['type'],
        'crone': json['crone'],
        'queueName': json['queueName'],
        'croneDescription': json['croneDescription'],
        'nextStart': (new Date(json['nextStart'])),
    };
}

export function GetJobConfigDtoToJSON(value?: GetJobConfigDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'active': value['active'],
        'systemNumber': value['systemNumber'],
        'type': value['type'],
        'crone': value['crone'],
        'queueName': value['queueName'],
        'croneDescription': value['croneDescription'],
        'nextStart': ((value['nextStart']).toISOString()),
    };
}

